import React, { useState, useEffect } from "react";
import { FormGrid } from "../../Users/AddANewUser";
import Input from "../../../Input";
import toast from "react-hot-toast";
import { UserService } from "../../../../services/UserService";
import { StockService } from "../../../../services/StockService";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";

const AddTeam = () => {
  const navigate = useNavigate();
  const [teamName, setTeamName] = useState("");
  const [supervisor, setSupervisor] = useState(null);
  const [manager, setManager] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    UserService.GetAllInternalUsers().then((res) => {
      setUsers(
        (res || []).map((user) => ({
          ...user,
          value: user.userId,
          label: `${user.firstName} ${user.lastName}`,
        }))
      );
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!teamName.trim()) {
      toast.error("Enter a team name.");
      return;
    }
    const toastId = toast.loading("Creating new Team ... ");
    // Description, driver and other members are no longer collected; the API still
    // expects the fields, so they go as empty / 0.
    StockService.CreateTeam(
      teamName.trim(),
      "",
      "",
      supervisor ? supervisor.value : 0,
      manager ? manager.value : 0,
      0
    ).then((res) => {
      toast.dismiss(toastId);
      if (res.Successful) {
        toast.success(res.message);
        navigate("/dashboard/users/teams");
      } else {
        toast.error(res.message);
      }
    });
  };

  const notPicked = (option) => (u) =>
    u.userId === option?.userId || (u.userId !== supervisor?.userId && u.userId !== manager?.userId);

  return (
    <form className="w-full flex flex-col" onSubmit={handleSubmit}>
      <h2 className=" text-xl font-medium text-gray-700 my-2">New Team</h2>
      <FormGrid>
        <label className="block">
          <span className="block text-md  text-gray-700 mb-3">
            Team Name
          </span>
          <Input
            placeholder="Team Name"
            type="text"
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            required
            id="teamName"
          />
        </label>
        <label className="block">
          <span className="block text-md  text-gray-700 mb-3">
            Supervisor
          </span>
          <Select
            inputId="supervisorId"
            options={users.filter(notPicked(supervisor))}
            value={supervisor}
            onChange={setSupervisor}
            isClearable
            placeholder="Select a supervisor (optional)"
          />
        </label>
        <label className="block">
          <span className="block text-md  text-gray-700 mb-3">
            Manager
          </span>
          <Select
            inputId="managerId"
            options={users.filter(notPicked(manager))}
            value={manager}
            onChange={setManager}
            isClearable
            placeholder="Select a manager (optional)"
          />
        </label>
      </FormGrid>
      <button
        type="submit"
        className="w-full sm:w-auto sm:px-3 bg-[#3e7c17] hover:bg-[#356C14] text-white font-semibold py-2 lg:py-3 my-3 rounded rounded-md self-end"
      >
        Create Team
      </button>
    </form>
  );
};

export default AddTeam;
